export type BoxShadowToken = keyof typeof boxShadowTokens;

export const boxShadowTokens = {
  "$shadow-raised": "var(--shadow-raised)",
  "$shadow-floating": "var(--shadow-floating)",
  "$shadow-hover-list": "var(--shadow-hover-list)",
};
